export default "__VITE_ASSET__5e6c10c0__"